SNI.Application.addBehavior('braze', context => {

  async function loadAndInitBraze() {
    if (!SNI.Config.braze?.enabled || window.braze) {
      debug.info('not initializing', { enabled: SNI.Config.braze?.enabled, braze: window.braze });
      return;
    }

    debug.info('initializing braze');
    const braze = await import('@braze/web-sdk' /* Braze library */);
    window.braze = braze;
    window.braze.initialize(SNI.Config.braze.key, {
      baseUrl: SNI.Config.braze.url,
      //enable logging when we are in debug mode
      enableLogging: context.getService('utility').isDebug(),
      allowUserSuppliedJavascript: true
    });

    // show all in-app messages without custom handling
    window.braze.automaticallyShowInAppMessages();

    // `openSession` should be called last - after `automaticallyShowInAppMessages`
    window.braze.openSession();
  }

  const mdManager = context.getGlobal('mdManager');
  const userInterface = context.getService('user/user-data');
  let debug = context.getService('logger').create('behavior.braze');

  function brazeDestroy() {
    debug.info('destroying braze:', window.braze);
    if (window.braze) {
      //teardown Braze SDK
      window.braze.destroy();
      //remove braze altogether to prevent reuse
      window.braze = undefined;
    }
  }

  const brazePageView = () => {
    if (!window.braze) { return; }

    const eventParams = {
      title: mdManager.getParameterString('Title'),
      categoryName: mdManager.getParameterString('CategoryDspName'),
      pageType: mdManager.getParameterString('Type'),
      url: mdManager.getParameterString('Url'),
      contentTags: [
        mdManager.getParameterString('ContentTag1'),
        mdManager.getParameterString('ContentTag2')
      ].filter(tag => !!tag).join(', '),
    };

    debug.log('BRAZE: PAGE-VIEW', eventParams);
    window.braze.logCustomEvent('PAGE-VIEW', eventParams);

  };

  const messageHandlers = {
    'dalton:logged-in': async (data) => {
      if (!userInterface.getUserId()) {
        debug.info('logged-in event with no user-id. ignoring wrt braze');
        return;
      }

      // Do not reinitialize if the user is the same
      if (window.braze && window.braze.getUser()?.getUserId() === userInterface.getUserId()) {
        debug.info('braze user is already initialized with the same user-id');
        return;
      }


      debug.info('user is logged in. ensuring braze is intialized');
      await loadAndInitBraze();

      debug.info('setting braze user');
      window.braze.changeUser(userInterface.getUserId());
      window.braze.getUser().setEmail(data.userEmail);

      brazePageView();

    },

    // This logged-out event fires when a logged in user logs out AND ALSO when there is no user
    'dalton:logged-out': async() => {

      if (SNI.Config.braze?.global) {

        if (!window.braze) {
          debug.info('logged out: braze is global so we are initializing it without a user');
          await loadAndInitBraze();
          brazePageView();
        } else {
          debug.info('logged out: braze is already initialized');
        }

      }

      if (!SNI.Config.braze?.global) {
        debug.info('logged out: braze is not global so we are destroying it');
        brazeDestroy();
      }
    },

    'braze:newsletter': (params) => {
      if (window.braze) {
        window.braze.logCustomEvent('NEWSLETTER', params);
        debug.log('BRAZE: NEWSLETTER');
      }
    },
    'braze:scroll-depth': (eventParams) => {
      if (window.braze) {
        window.braze.logCustomEvent('SCROLL-DEPTH', eventParams);
        debug.log('BRAZE: SCROLL-DEPTH: ', eventParams?.scrollDepth);
      }
    },
    'braze:affiliate-brand-button': (data) => {
      const brazeData = data.split('|');
      const eventParams = {
        brand: brazeData[0],
        name: brazeData[1],
        date: new Date()
      };

      debug.log(eventParams);

      if (window.braze) {
        window.braze.logCustomEvent('AFFILIATE-BRAND-BUTTON', eventParams);
        debug.log('BRAZE: AFFILIATE-BRAND-BUTTON');
      }
    },
    'braze:sweepstakes-email-entry': () => {
      if (window.braze) {
        window.braze.logCustomEvent('SWEEPSTAKES-EMAIL-ENTRY', {
          sweepstakeId: mdManager.getParameterString('SweepsID'),
          brand: mdManager.getParameterString('Site'),
          sweepstakeName: mdManager.getParameterString('Title'),
          date: new Date()
        });
        debug.log('BRAZE: SWEEPSTAKES-EMAIL-ENTRY');
      }
    },
    'braze:sweepstakes-form-sent': () => {
      if (window.braze) {
        window.braze.logCustomEvent('SWEEPSTAKES-FORM-SENT', {
          sweepstakeId: mdManager.getParameterString('SweepsID'),
          brand: mdManager.getParameterString('Site'),
          sweepstakeName: mdManager.getParameterString('Title'),
          date: new Date()
        });
        debug.log('BRAZE: SWEEPSTAKES-FORM-SENT');
      }
    },
    'braze:video-start': ({title, contentTags}) => {
      if (window.braze) {
        window.braze.logCustomEvent('VIDEO-START', {
          categoryName: mdManager.getParameterString('CategoryDspName'),
          title,
          contentTags
        });
        debug.log('BRAZE: VIDEO-START');
      }
    },
    'braze:video-end': ({title, contentTags}) => {
      if (window.braze) {
        window.braze.logCustomEvent('VIDEO-END', {
          categoryName: mdManager.getParameterString('CategoryDspName'),
          title,
          contentTags
        });
        debug.log('BRAZE: VIDEO-END');
      }
    }
  }; //end messageHandlers

  return {
    messages: Object.keys(messageHandlers),
    onmessage(msg, data) {
      messageHandlers[msg](data);
    },
  };
});
